export const entityCacheLimit = 300000 // 5mins === 5 * 60 * 1000
export const dashboardInfoCacheLimit = 3600000 // 1 hour = 60 * 60 * 1000
